export const DEFAULT_ACTIONS = {
    EDIT: {
        key: "EDIT",
        label: "Edit",
        icon: "lucide:pencil",
        iconWidth: 14,
        className: "edit-btn",
    },
    DELETE: {
        key: "DELETE",
        label: "Delete",
        icon: "lucide:trash-2",
        iconWidth: 14,
        className: "delete-btn",
    },
    VIEW: {
        key: "VIEW",
        label: "View",
        icon: "lucide:eye",
        iconWidth: 14,
        className: "view-btn",
    },
};